import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: "6ccb8d54-1228-4537-851d-d4189ddff534",
        authority: "https://login.microsoftonline.com/a1eae0da-f0d1-449d-8854-f54ddbda8711",
        redirectUri: "https://ai.xlaxiata.co.id/",
        // redirectUri: "http://localhost:5173/",
        postLogoutRedirectUri: "/"
    },
    system: {
        allowNativeBroker: false // Disables WAM Broker
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
